import React, {
    useEffect, useState, useMemo, useCallback, useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {
    Icon, Loader, InfoLabel, DateField,ModalNextProvider
} from '@jutro/components';
import ReactGA from 'react-ga4';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ServiceManager } from '@jutro/services';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { PolicyService } from 'gw-capability-policy';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { DocumentService } from 'gw-capability-policydocument';
import {
    DateRangeComponent,
    Link,
    Currency as CurrencyField,
    Link as HyperLink,
    PhoneNumber
} from 'gw-components-platform-react';
import { getNormalizedLOBName, isCapabilityEnabled } from 'gw-portals-config-js';
import { useAuthentication } from 'gw-digital-auth-react';
import { /* LobIconUtil,*/ LocalDateUtil } from 'gw-portals-util-js';
import { generateURL } from 'gw-portals-url-js';
import { IntlContext, TranslatorContext } from '@jutro/locale';
import { ButtonLink } from '@jutro/router';
import {getImageSrc, getProductName} from './../../customer/utils/lobIconUtil';
import {getBrokerUtilLogo} from './../../customer/utils/brokerLogoUtil';
import PageBannerComponent
    from '../../components/PageBannerComponent/PageBannerComponent';


// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import { ClaimService } from 'gw-capability-claim';
import { getFontIcon } from '../../customer/utils/lobIconUtil';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import claimDetailsStyles
    from '../../customer/capabilities-react/nexus-capability-claim-react/pages/ClaimDetails/ClaimDetails.module.scss';
import { PhoneUtil } from 'gw-portals-viewmodel-js';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import PaperlessDistibutionComponent from '../PaperlessDistribution/PaperlessDistibutionComponent';

const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness = activePeriod.lines.length > 1
        ? activePeriod.lines.map((line) => line) : _.first(activePeriod.lines);
    const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : getFontIcon(lineOfBusiness);
    return <Icon icon={icon} aria-label={lineOfBusiness} title={lineOfBusiness} key={lineOfBusiness} />;
};

const isPolicyActive = (periods) => {
    const currentRenewed = periods.length > 1;
    const activePeriod = _.first(periods);
    return new Date(activePeriod.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => {
    return accountPolicyData.some((policy) => policy.periods.length > 1);
};

const getCellStatus = (rowData) => {
    if (isPolicyActive(rowData.periods)) {
        return <InfoLabel type="success" size="medium" message={messages.statusActive} />;
    }

    return <InfoLabel type="info" size="medium" message={messages.statusRenewed} />;
};

const getCellPolicy = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <Link
            className={styles.link}
            to={{
                pathname: `/account-policy-details/${activePeriod.policyId}`,
                productCode: activePeriod.lines[0],
                idCard: periodWithIDCard ? {
                    idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                    idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                } : null
            }}
        >
            {activePeriod.policyId}
        </Link>
    );
};

const getPolicyNumber = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <span className={styles.link}>
            {activePeriod.policyId}
        </span>
    );
};

const getViewPolicyBtn = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <>

            <ButtonLink
                id={`viewPolicy_${rowIndex}`}
                // className={styles.eyButtonCard}
                to={{
                    pathname: `/account-policy-details/${activePeriod.policyId}`,
                    productCode: activePeriod.lines[0],
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                View Details
            </ButtonLink>
            <br />
        </>
    );
};

const getViewAutoPolicyBtn = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <>

            <ButtonLink
                id={`viewPolicy_${rowIndex}`}
                // className={styles.eyButtonCard}
                to={{
                    pathname: `/account-policy-details/${activePeriod.policyId}`,
                    productCode: activePeriod.lines[0],
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                Take Me to Digital Pink Slip
            </ButtonLink>
            <br />
        </>
    );
};

const getCellEffective = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateRangeComponent
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod}
            fromDate="effective"
            toDate="expiration"
            hideLabel
        />
    );
};

const getPolicyEffectiveDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.effective}
            format="short"
            dataType={_.isString(activePeriod.effective) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getPolicyExpiryDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.expiration}
            format="short"
            dataType={_.isString(activePeriod.expiration) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};


const getCellClaim = (rowData) => {
    const activePeriod = _.first(rowData.periods);

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: activePeriod.policyId,
            redirectPath: '/home',
            claimData: { lossDate: new Date() }
        }
    };
    return (
        <Link to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </Link>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.displayName}
        </span>
    );
};

const getCellBillingPlan = (rowData) => {
    return (
        <span>
            {rowData.periodicity}
        </span>
    );
};

const getCellLastPaymentDate = (rowData, rowIndex) => {
    const invoices = rowData.invoiceSummary;
    const latestDate = new Date(Math.max(...invoices.map((e) => new Date(e.lastPaymentDate))));
    if (latestDate.toString() === 'Invalid Date') {
        return (
            <span>
                No Payments Received
            </span>
        );
    }
    return (
        <DateField
            id={`latestDate_${rowIndex}`}
            value={latestDate}
            format="short"
            dataType={_.isString(latestDate) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellLastPayment = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`paidAmount_${rowIndex}`}
            value={rowData.paidAmount}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBalanceDue = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`dueAmount_${rowIndex}`}
            value={rowData.balance}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBillingDetail = (rowData, rowIndex) => {
    return (
        <ButtonLink
            id={`viewBilling_${rowIndex}`}
            className={styles.link}
            to={{
                pathname: `/billing-summary/${rowData.internalId}`
            }}
        >
            Details
        </ButtonLink>
    );
};




const getCellClaimPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.policyNumber}
        </span>
    );
};

const getCellDateOfLoss = (rowData, rowIndex) => {
    return (
        <DateField
            id={`dateOfLoss_${rowIndex}`}
            value={rowData.dateOfLoss}
            format="short"
            dataType={_.isString(rowData.dateOfLoss) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellClaimNumber = (rowData) => {
    return (
        <span>
            {rowData.claimNumber}
        </span>
    );
};

const getCellClaimDetail = (rowData, rowIndex) => {
    if (rowData.status === 'draft') {
        const redirectPath = {
            pathname: '/fnol-select-policy',
            state: {
                claimNumber: rowData.claimNumber,
                redirectPath: '/claims',
                claimStatus: rowData.status
            }
        };
        return (
            <ButtonLink
                id={`viewClaim_${rowIndex}`}
                className={styles.link}
                to={redirectPath}
            >
                Details
            </ButtonLink>
        );
    }
    const redirectPath = {
        pathname: `/claims/${rowData.claimNumber}`,
        state: {
            claimNumber: rowData.claimNumber,
            redirectPath: '/claims',
            claimStatus: rowData.status
        }
    };
    return (
        <ButtonLink
            id={`viewClaim_${rowIndex}`}
            className={styles.link}
            to={redirectPath}
        >
            Details
        </ButtonLink>
    );
};


function LandingPage(props) {
    const translator = useContext(TranslatorContext);
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    const { authHeader, updateUserProvince, getUserProvince } = useAuthentication();
    const [accountData, setAccountData] = useState([]);
    const [billingDetailsData, setBillingDetailsData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const { capabilitiesConfig, showGreeting, kingsAddress, kingsEmail } = appConfig;
    const [claimDataTable, setClaimDataTable] = useState([]);
    const [hasBillingError, setHasBillingError] = useState(false);
    const [isInitialLogin, setInitialLogin] = useState(true);
    const intl = useContext(IntlContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const localeService = ServiceManager.getService('locale-service');
    const viewModelService = useContext(ViewModelServiceContext);
    const [ showPaymentNotification, setPaymentNotification] = useState(false);
    // let [policiesLobMap, setPoliciesLobMap] = useState({});
    //  const policiesLobMap = new Map();

    useEffect(() => {
        const { googleAnalytics } = appConfig;
        if (googleAnalytics.tracking) {
            ReactGA.send({ hitType: 'pageview', page: '/dashboard', title: 'CE Dashboard' });
        }
    }, []);

   
    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;
                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        policyLOBCode: claimInfo.lineOfBusinessCode,
                        claimNumber: claimInfo.claimNumber,
                        dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                        status: claimInfo.claimState,
                        policyNumber: claimInfo.policyNumber
                    };
                    return claims;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );

    const getClaims = useCallback(
        (query) => {
            const claimsPromise = ClaimService.getClaimSummaries(query, {}, authHeader);
            return claimsPromise
                .then((responseData) => {
                    const data = processClaimsData(responseData.items);
                    setClaimDataTable(data);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader, processClaimsData]
    );

    const query = {
        claimStates: ['open', 'closed']
        // claimStates: ['open', 'draft', 'closed'] // Commented for deminishing the FNOL flow
    };

    // const setPoliciesLobMap1 = () => {
    //     const policiesLobMap1 = new Map();
    //     accountPolicyData.forEach((accountPolicy) => {
    //         const periods = _.first(accountPolicy.periods);
    //         const policyLines = periods.lines;
    //         if (policyLines !== null && policyLines.length > 0) {
    //             policiesLobMap1.set([periods.policyId], periods.lines);
    //         }
    //         //
    //     });
    //     return policiesLobMap1;
    // };

    const handleError = (error) => {
        console.log('Error in API', error);
    };

    const getCellProduct = (rowData) => {
        const lobCode = rowData.policyLOBCode;
        const icon = getFontIcon(lobCode);
        return <span className="iconFocus" tabindex="0"> <Icon role="img" aria-label={translator({ id: `typekey.LOBCode.${lobCode}` })} icon={icon} title={translator({ id: `typekey.LOBCode.${lobCode}` })} key={lobCode} /></span>;
    };

    const trimEmptyPeriodsFromPolicies = (response) => {
        let data = [];
        if (response && response.length > 0) {
            data = _.filter(response, (policySummary) => {
                return policySummary.periods !== undefined && policySummary.periods.length > 0
                    && (policySummary.periods[0].productCode !== 'BusinessFleet' && policySummary.periods[0].productCode !== 'GA7Garage' && policySummary.periods[0].productCode !== 'PersonalUmbrella');
            });
        }
        let userProvince = 'ON';
        if (data && data.length > 0) {
            const states = data.map((policyData) => policyData.baseProvince);
            userProvince = states && states.includes('ON') ? 'ON' : states[0];
        }
        updateUserProvince(userProvince);
        if (localeService.getPolicyProvince() !== userProvince) {
            localeService.savePolicyProvince(userProvince);
        }
        setAccountPolicyData(data);
        if(response != null){
            //checkPaperlessCondition(response);
            // if(isInitialLogin){
            //     checkPaperlessCondition(data);
            // }
        const value = localStorage.getItem('alreadyVisited');
        if ( _.isNull(value) || _.isUndefined(value) || value != 'true'){
            checkPaperlessCondition(response);
            localStorage.setItem('alreadyVisited', 'true');
        }
      }
    };

    const createPolicySummaryVM = (data) => {
        return viewModelService.create(
            data,
            'pc',
            'edge.capabilities.policy.dto.PolicyBasicDetailsDTO'
        );
    };

    

    useEffect(() => {
        setLoadingState(true);
        try {
            if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                // PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData, handleError),
                PolicyService.getUserPolicySummaries(authHeader).then(trimEmptyPeriodsFromPolicies, handleError),
                    UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(setAccountData, handleError);
                /*,
                    getClaims(query);*/
            }
        } finally {
            setLoadingState(false);
        }

        setLoadingState(true);
        try {
            // let billingAccData = '';
            if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                // billingAccData = AccountBillingDetailsService.getAccountBillingSummary(authHeader);
                // eslint-disable-next-line max-len
               AccountBillingDetailsService.getUserBillingDetails_EY(authHeader).then((billingResponse)=>{
                setBillingDetailsData(billingResponse);
                checkForpaymentNotification(billingResponse);
               })
               .catch(handleError);
               console.log("Billing Data"+billingDetailsData);
            }
        } finally {
            setLoadingState(false);
        }
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

   


    const checkPaperlessCondition = useCallback((policySummaryData)=>{
        const { history } = props;
        setInitialLogin(false);
        if (policySummaryData.length === 0) {
            return null;
        }
        let policiesWithPaperlessOption = policySummaryData.filter((policy)=>{
            return (policy.dispatchMode_EY.includes("DigitiallyDelivered"))
            //return (policy.dispatchMode_EY.includes("EdocDeliveryToBroker"))
        })
        if(policiesWithPaperlessOption.length > 0){
            let nonPaperlessPolicies = policiesWithPaperlessOption.filter((policy)=>{
                return (policy.policyDocDispatchMode !== "DigitiallyDelivered")
                //return (policy.policyDocDispatchMode !== "EdocDeliveryToBroker")
            })
          
            if(nonPaperlessPolicies.length >=1){
                const today = new Date()
                
                ModalNextProvider.showModal(
                    <PaperlessDistibutionComponent  
                    data={nonPaperlessPolicies}
                    history ={history}
                     />
                ).then((res)=>{
                    const _accountPolicyData = _.clone(policySummaryData)
                    _accountPolicyData.map((policy)=>{
                        if((policy.dispatchMode_EY.includes("DigitiallyDelivered")) && (policy.policyDocDispatchMode !== "DigitiallyDelivered")){
                            _.set(policy, 'policyDocDispatchMode', "DigitiallyDelivered");
                            _.set(policy, 'electronicConsent_EY', today)
                        }
                    })
                    setAccountData(_accountPolicyData);

                    const accountPoliciesValue = _accountPolicyData.filter((data) => data.periods && data.periods.length > 0
                                    && (data.billingMethod_EY === 'DirectBill'))
                                    .map((policySummary) => {
                                        return createPolicySummaryVM({
                                            policyNumber: policySummary.policyNumber,
                                            productCode: policySummary.periods[0].productCode,
                                            accountNumber: policySummary.accountNumber,
                                            policyDocDispatchMode: policySummary.policyDocDispatchMode,
                                            policyDocDispatchModeValue: policySummary.policyDocDispatchModeValue,
                                            dispatchMode_EYValue : policySummary.dispatchMode_EYValue,
                                            dispatchMode_EY: policySummary.dispatchMode_EY,
                                            electronicConsent_EY: policySummary.electronicConsent_EY
                                        });
                                    });
                                    
                    const policiesValues = accountPoliciesValue.map((data) => data.value);
                    PolicyService.updatePolicyDocumentPreference(policiesValues, authHeader)
                        .then((response) => {
                        //     try {
                        //        return  ModalNextProvider.showAlert({
                        //            title: messages.optOutForPaperlessTitle,
                        //            message: messages.optOutForPaperlessMessage,
                        //            status :'success',
                        //             icon:"mi-mail",
                        //            confirmButtonText: messages.ok,
                        //            className: styles.paperlessModalBoxWidth
                        //        });
                        //    } catch (args) {
                        //        return _.noop(args);
                        //    }
                        }).catch((error) => {
                            
                        }).finally(() => {
                    });
               
                })
                .catch(_.noop);
              
            }
        }
        
    },[]);

    const checkForpaymentNotification = useCallback((billingResponse)=>{
        if(!_.isUndefined(billingResponse) && billingResponse != null){
            const hasOverdue = billingResponse.some(billingData => billingData.isDue_EY === true);
            setPaymentNotification(hasOverdue);
        }
    },[])

    const getPolicyNextPaymentDate = useCallback((rowData, rowIndex)=>{
    const activePeriod = _.first(rowData.periods);
    const policyNumber = activePeriod.policyId;
    if( !_.isUndefined(billingDetailsData) && billingDetailsData != null){
        const policyBillingData = billingDetailsData.find((billingData)=> billingData.displayName === policyNumber);
        if(policyBillingData != null){
            const paymentMethod = policyBillingData.paymentInstrument.paymentMethod;
            const nextpaymentDate = paymentMethod === 'responsive' ? policyBillingData.dueDate_EY : policyBillingData.billDate_EY;
            const isOverDue = policyBillingData.isDue_EY;
            const className = isOverDue ? styles.highlightedText : styles.normalText;
           
            return (
                <DateField
                    id={`nextpaymnetDate_${rowIndex}`}
                    value={nextpaymentDate}
                    format="short"
                    dataType={_.isString(nextpaymentDate) ? 'string' : 'object'}
                    readOnly
                    hideLabel
                    layout="full-width"
                    className={className}
                />
            );
        }
    }
},[billingDetailsData])


    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;
            const newDue = new Date(invoice.dueDate);
            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;
                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }
            return null;
        },
        [accountBillingData.activeInvoices, aggregateBilling]
    );

    const getCellClaimStatus = (rowData, rowIndex, rowProperty) => {
        const titleMessage = translator(messages.claimStatus);
        const status = rowData[rowProperty.id];
        let typeStatus = 'success';
        if (status === 'draft') {
            typeStatus = 'warning';
        } else if (status === 'closed') {
            typeStatus = 'neutral';
        }
        const claimState = translator({
            id: `typekey.ClaimState.${rowData[rowProperty.id]}`,
            defaultMessage: rowData[rowProperty.id]
        })
        return (
            /*<InfoLabel type={typeStatus} size="small" title={titleMessage[rowProperty.id]}>
                {claimState}
            </InfoLabel>*/
            claimState
        );
    };

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }
        if (overdue || current) {
            return (overdue || current).amountDue;
        }
        return null;
    }, [getMyBalanceOverDueAndCurrentData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }
            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }
            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }
            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }
            if (path === 'myCards') {
                return accountPolicyData;
            }
            return _.get(accountPolicyData, path);
        },
        [accountPolicyData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;
        accountPolicyData.some((policyData) => {
            return policyData.periods.some((period) => {
                if (period.idCardPublicID) {
                    periodWithIDCard = period;
                    return true;
                }
                return false;
            });
        });
        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useMemo(() => {
        if (!policyWithIDCard) {
            return null;
        }
        return DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }
        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => {
        return accountData.length <= 1 && !_.isEmpty(accountData);
    }, [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' });
    }, [capabilitiesConfig]);

    const onQuoteQuickLinkClick = useCallback(
        (lob) => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today()
                }
            };
            AMPSubmissionDraftService.createForAccount(submission, authHeader).then(
                (savedSubmission) => {
                    const { url } = appConfig.quoteAndBuy;
                    const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                    const params = {
                        quoteID: savedSubmission.quoteID,
                        postalCode: savedSubmission.baseData.policyAddress.postalCode
                    };

                    window.location = generateURL(location, params);
                }
            );
        },
        [accountData, authHeader]
    );

    const getCellAgent = useCallback(
        (rowData) => {
            return (
                <>
                    <Link className={styles.link} onClick={(e) => mailToTrigger(e, rowData.producerContact.email)} href="/">
                        {rowData.producerContact.displayName}
                    </Link>
                    <br />
                    {rowData.producerContact.phoneNumber ? (
                        <span>
                            {translator(messages.policyDetailsTel)}
                            {rowData.producerContact.phoneNumber}
                        </span>
                    ) : (
                        ''
                    )}
                </>
            );
        },
        [mailToTrigger, translator]
    );

    const renderHeaderData = useCallback(
        (rowData) => {
            const activePeriod = _.first(rowData.periods);
            // const lineOfBusiness = _.first(activePeriod.lines);
            const lineOfBusiness = activePeriod.productCode;
            //    let lOB = lineOfBusiness == 'HOPBoat_EY' ? 'InlandMarine' : lineOfBusiness;
            //  const icon = LobIconUtil.getFontIcon(lOB);
            const icon = getFontIcon(lineOfBusiness);
            const classb = lineOfBusiness === 'BusinessOwners' ? styles.eyCPPolicyTypeIcon : styles.eyPolicyTypeIcon;
            const prodName = getProductName(lineOfBusiness);
            return (
                <span>
                    <Icon icon={icon} title={prodName} key={lineOfBusiness} size="50px" className={classb} />
                    <span className={styles.eyCardHeaderText}>
                        {activePeriod.productDisplayName}
                    </span>
                </span>
            );
        },
        []
    );

    const getTableOverrides = useCallback(() => {
        return {
            typeColumn: { onCell: getCellType },
            statusColumn: { onCell: getCellStatus },
            policyColumn: { onCell: getCellPolicy },
            effectiveColumn: { onCell: getCellEffective },
            premiumColumn: { onCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                onCell: getCellClaim
            },
            agentColumn: {
                visible: accountData.length > 1,
                onCell: getCellAgent
            }
        };
    }, [accountData, getCellAgent]);

    const generatePolicyCardOverrides = useCallback(() => {
        const overrides = accountPolicyData.map((accountPolicy, index) => {
            if (accountPolicy.periods !== undefined && accountPolicy.periods.length > 0) {
                return {
                    [`myPolicyNo${index}`]: {
                        content: getPolicyNumber(accountPolicy)
                    },
                    /* [`myPolicyStatus${index}`]: {
                        content: getCellStatus(accountPolicy)
                    }, */
                    [`myPolicyEffectiveDate${index}`]: {
                        content: getPolicyEffectiveDate(accountPolicy)
                    },
                    [`myPolicyExpiryDate${index}`]: {
                        content: getPolicyExpiryDate(accountPolicy)
                    },
                    [`myPolicyNextPaymentDate${index}`]:{
                        content: getPolicyNextPaymentDate(accountPolicy)
                    },
                    [`viewPolicyBtn${index}`]: {
                        content: getViewPolicyBtn(accountPolicy, index)
                    },
                    [`viewAutoPolicyBtnGridItem${index}`]: {
                        visible: accountPolicy.periods[0].productCode === 'BusinessAuto'
                    },
                    [`viewAutoPolicyBtn${index}`]: {
                        content: getViewAutoPolicyBtn(accountPolicy, index)
                    },
                    [`policyCard${index}`]: {
                        header: renderHeaderData(accountPolicy)
                    },

                };
            }
            return;
        });

        return Object.assign({}, ...overrides);
    }, [accountPolicyData,billingDetailsData]);


    const generateBillingDetailsOverrides = useCallback(() => {
        return {
            productTypeColumn: { onCell: getCellProduct },
            policyNumberColumn: { onCell: getCellPolicyNumber },
            billingPlanColumn: { onCell: getCellBillingPlan },
            lastPaymentColumn: { onCell: getCellLastPayment },
            lastPaymentDateColumn: { onCell: getCellLastPaymentDate },
            balanceDueColumn: { onCell: getCellBalanceDue },
            billingViewColumn: {
                onCell: getCellBillingDetail
            }
        };
    }, [billingDetailsData]);

    const generateClaimDetailsOverrides = useCallback(() => {
        return {
            productColumn: { onCell: getCellProduct },
            policyNumberClaimColumn: { onCell: getCellClaimPolicyNumber },
            claimNumberColumn: { onCell: getCellClaimNumber },
            dateOfLossColumn: { onCell: getCellDateOfLoss },
            statusColumn: { onCell: getCellClaimStatus },
            claimDetailViewColumn: {
                onCell: getCellClaimDetail
            }
        };
    }, [claimDataTable]);

    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );

    const onFileAClaimButtonClick = useCallback(
        () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );


    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;
            return history.push(event.path);
        },
        [props]
    );

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, []);

    const phoneToTrigger = (event, agentPhone) => {
        event.preventDefault();
        window.location = `tel:${agentPhone}`;
    };


    const getPhoneLink = (phoneNo) => {
        const agentPhone = phoneNo;
        if (!agentPhone) {
            return null;
        }

        return (
            <span>
                {/* eslint-disable-next-line max-len */}
                <Link className={styles.fontSizesmall} onClick={(e) => phoneToTrigger(e, phoneNo)}
                    href="/">
                    Phone: {phoneNo}
                </Link>
            </span>
        )
    };

    const getEmailLink = (email) => {
        if (!email) {
            return null;
        }

        return (
            <span>
                {/* eslint-disable-next-line max-len */}
                <Link className={styles.fontSizesmall} onClick={(e) => mailToTrigger(e, email)} href="/">
                    {email}
                </Link>
            </span>
        );
    };

    

    const getNeedHelpLink = useMemo(() => {
        return (
            <span>
                {translator(messages.needHelpText)}
                {' '}
                <Link className={styles.hyperlink} onClick={(e) => phoneToTrigger(e, appConfig.optimPhoneNo)} href="/">
                    {appConfig.optimPhoneNo}
                </Link>
				&nbsp; Ext. 9020&nbsp;or email at&nbsp;
                <Link className={styles.hyperlink} onClick={(e) => mailToTrigger(e, appConfig.optimEmail)} href="/">
                    {appConfig.optimEmail}
                </Link>
            </span>

        );
    }, [translator]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const src = getBrokerUtilLogo(accountPolicyData);

    const getAdvisorName = useCallback(() => {
        let agentName = _.get(accountPolicyData[0], 'producerContact.organizationDescription')
        if (_.isEmpty(agentName)) {
            return translator(messages.na)
        }
        return agentName;
    }, [translator, accountPolicyData]);

    const getAdvisorPhone = useCallback(() => {
        let phoneNumber = _.get(accountPolicyData[0], 'producerContact.phoneNumber');
        const localeService = ServiceManager.getService('locale-service');
        const phoneUtil = PhoneUtil();
        const agentPhone =  phoneUtil.prettyPrint(phoneNumber, localeService.getDefaultCountryCode());
        if (_.isEmpty(agentPhone)) {
            return translator(messages.na)
        }
        return (
            <Link aria-label="Agent phone number" className={styles.customLink} onClick={(e) => phoneToTrigger(e, agentPhone)} href="/">
           {agentPhone}
            </Link>
        )
    }, [accountPolicyData]);

    const getAdvisorEmail = useCallback(() => {
        const agentEmail = _.get(accountPolicyData[0], 'producerContact.email');
        if (_.isEmpty(agentEmail)) {
            return translator(messages.na);
        }
        return (
            <Link className={styles.customLink} onClick={(e) => mailToTrigger(e, agentEmail)} href="/">
                {agentEmail}
            </Link>
        );
    }, [accountPolicyData]);

    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            }
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        myBalanceCurrentAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length > 1
        },
        policiesTable: {
            data: accountPolicyData
        },
        billingTable: {
            data: billingDetailsData
        },
        billingEmpty: {
            visible: _.isEmpty(billingDetailsData)
        },
        printAnIDCardLink: {
            visible: !_.isNil(policyWithIDCard),
            href: getIDCardQuickLink,
            target: '_blank'
        },
        setupAutomatedPaymentsLink: {
            to: automatedPaymentURL,
            visible: !!automatedPaymentURL && showBillingSection
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        agentCompany: {
            content: 'ABC Insurance Brokers Ltd'
        },
        agentName: {
            content: 'MARTHA STEWART, CIP'
        },
        agentAddressLine1: {
            content: '123 Main Street, Ajax, ON, JSM 509'
        },
        agentPhone: {
            content: 'Phone: 905-352-6784'
        },
        agentEmail: {
            content: 'Email: martha.stewart@insurance.com'
        },
        contactUsCompany: {
            content: 'Trillium Mutual'
            // content: 'EY Canada'
        },
        contactUsCompanyLine1: {
            content: 'Insurance Company'
        },
        /*contactUsAddressLine1: {
            content: localeService.getPolicyProvince() === 'ON' ? '100 Erb Street, East Waterloo,' : kingsAddress.addressLine1
            // content: '100 Adelaide St W, Toronto, ON M5H 0B3'
        },*/
        /*contactUsAddressLine2: {
            content: localeService.getPolicyProvince() === 'ON' ? 'ON N2J 1L9' : kingsAddress.addressLine2
        },*/
        contactUsPhone: {
            // content: getPhoneLink(translator(messages.phone, { phoneNo: appConfig.adjusterPhoneNumber })
            // content: localeService.getPolicyProvince() === 'ON' ? getPhoneLink(appConfig.adjusterPhoneNumber) : getPhoneLink(kingsAddress.phone)
            content: getPhoneLink(appConfig.adjusterPhoneNumber)
        },
        /*contactUsFax: {
            content: localeService.getPolicyProvince() === 'ON' ? 'Fax: 519-746-0222' : kingsAddress.fax
        },*/
        contactUsEmail: {
            // content: localeService.getPolicyProvince() === 'ON' ? getEmailLink(appConfig.adjusterEmail) : getEmailLink(appConfig.kingsEmail),
            content: getEmailLink(appConfig.adjusterEmail)
        },
        /*contactUsForOptim: {
            content: localeService.getPolicyProvince() === 'ON' ? '100 Erb Street, East Waterloo,' : kingsAddress.addressLine1
            // content: '100 Adelaide St W, Toronto, ON M5H 0B3'
        },*/
        contactUsOptimPhone: {
            content: getPhoneLink(appConfig.optimPhoneNo)
        },
        contactUsBillingEmail: {
            content: getEmailLink(appConfig.billingEmail)
        },
        contactUsOptimEmail: {
            content: getEmailLink(appConfig.optimEmail)
        },
        repeatCard: {
            data: accountPolicyData
        },
        claimsTable: {
            data: claimDataTable
        },
        claimEmpty: {
            visible: _.isEmpty(claimDataTable)
        },
        fileClaimButton: {
            to: onFileAClaimButtonClick
        },
        welcomeId: {
            content: `Welcome ${useAuthentication().given_name}!`
        },
        welcomeGridItem: {
            visible: showGreeting
        },
        ContactUsLogoImage: {
            src: localeService.getPolicyProvince() === 'ON' ? getImageSrc('branding/HMI-Optim.png') : getImageSrc('branding/Kings-Logo-HFM-Blue.png')
        },
        needHelpSection: {
            content: getNeedHelpLink,
        },
        advisorName: {
            content: getAdvisorName()
        },
        advisorPhone: {
            content: getAdvisorPhone()
        },
        advisorEmail: {
            content: getAdvisorEmail()
        },
        brokerLogoImage:{
            visible: !!src,
             src: src
        },
        paymentNotificationContainer:{
            visible: showPaymentNotification
        },
        ...getTableOverrides(),
        ...generatePolicyCardOverrides(),
        ...generateBillingDetailsOverrides(),
        ...generateClaimDetailsOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            onFileAClaimButtonClick
        },
        resolveComponentMap: {
            pagebannercomponent: PageBannerComponent
        }
    };

    return renderContentFromMetadata(metadata.pageContent, override, resolvers);
}

export default withRouter(LandingPage);
